import PropTypes from 'prop-types';
import ZohoForm from 'components/ZohoForm';

const ZohoFormBlock = ({ value }) => (
  <section className='cms-block cms-block--zoho-form py-6 md:py-6 lg:py-8'>
    <div className='w-full md:max-w-2xl lg:max-w-2xl mx-auto px-6'>
      <ZohoForm hash={value?.hash || ''} questions={value?.questions || []} />
    </div>
  </section>
);

ZohoFormBlock.propTypes = {
  value: PropTypes.shape({
    hash: PropTypes.string,
    questions: PropTypes.array,
  }).isRequired,
};

export default ZohoFormBlock;
